import { FieldSyncAssetUpdatedEvent, } from '../event/field-sync-asset-updated.event';
const fieldSyncAssetUpdatedProjections = {
    [FieldSyncAssetUpdatedEvent.name]: (event, state) => {
        const payload = event.getPayload();
        return {
            ...state,
            attributes: payload.attributes,
        };
    },
};
export default fieldSyncAssetUpdatedProjections;
//# sourceMappingURL=field-sync-asset-updated.projection.js.map